// components/Header.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../config/firebase";
import { ChevronDown } from "lucide-react";

const Header = ({ user, onLogout }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    console.log("Current user after sign out:", auth.currentUser);
    navigate("/explore");
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown when user changes (e.g., logout or login)
  useEffect(() => {
    setDropdownOpen(false);
  }, [user]);

  const handleNavigate = (path) => {
    setDropdownOpen(false);
    navigate(path);
  };

  return (
    <header className="flex justify-between items-center py-3 sm:py-4 bg-white border-b border-gray-200 mb-4 sm:mb-6 px-4 sm:px-0">
      <button 
        onClick={() => navigate("/explore")}
        className="text-xl sm:text-2xl font-bold text-green-700 hover:text-green-800 transition-colors cursor-pointer"
      >
        GymMix
      </button>
      {user ? (
        <div className="relative" ref={dropdownRef}>
          <button
            className="flex items-center gap-2 text-gray-800 font-medium focus:outline-none"
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            {user.displayName || "User"}
            <ChevronDown className="w-4 h-4" />
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-56 bg-white border rounded shadow-md z-50">
              <button
                onClick={() => handleNavigate("/library")}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                My Library
              </button>
              <button
                onClick={() => handleNavigate("/custom-workout")}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Create Custom Workout
              </button>
              {/* New Explore/Search menu item */}
              <button
                onClick={() => handleNavigate("/explore")}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Explore
              </button>
              <button
                onClick={handleLogout}
                className="text-sm text-red-500 hover:text-red-700 block w-full text-left px-4 py-2"
              >
                Log Out
              </button>
            </div>
          )}

        </div>
      ) : (
        <button
          onClick={() => {
            // Save current page for post-login return
            localStorage.setItem("pendingBookmark", JSON.stringify({ returnUrl: window.location.pathname }));
            navigate("/login");
          }}
          className="text-gray-700 hover:text-gray-900 font-medium transition-colors"
        >
          Log In
        </button>
      )}
    </header>
  );
};

export default Header;
